import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 32, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ overline, title, dark = false, className = "" }) => (
  <Reveal className={className}>
    <p className={`text-xs uppercase tracking-[0.25em] mb-4 ${dark ? "text-sun" : "text-sun"}`} data-testid="section-overline">{overline}</p>
    <h2 className={`font-display text-4xl sm:text-5xl font-black leading-[1.05] ${dark ? "text-bone" : "text-ink"}`}>
      {title}
    </h2>
  </Reveal>
);
